'use strict';

var _ = require('lodash');
var AdvancedHepGridReloadConfigurationCacheCityAptsService = function AdvancedHepGridReloadConfigurationCacheCityAptsService(foCityAptsService) {
  function reloadConfigurationCacheForMode(mode) {
    switch (mode) {
      case 'fo-cityapts':
        foCityAptsService.loadFoCityApts();
        break;
    }
  }
  function reloadCityApts() {
    foCityAptsService.loadFoCityApts();
  }
  return {
    reloadConfigurationCacheForMode: reloadConfigurationCacheForMode,
    reloadCityApts: reloadCityApts
  };
};
AdvancedHepGridReloadConfigurationCacheCityAptsService.$inject = ['FOCityAptsService'];
module.exports = AdvancedHepGridReloadConfigurationCacheCityAptsService;